export default "__VITE_ASSET__CpoUDRE___"